import React, { FunctionComponent, useState } from 'react';
import { Space, Typography, Spin, Empty } from 'antd';

import { DownOutlined } from '@ant-design/icons';
import css from './ComplaintsReasonsList.module.less';
import cn from 'classnames';
import componentContent from '@fields/ShowMore/ShowMore.module.json';
import useTranslate from '@hooks/useTranslate';

interface ComplaintsReasonsListProps {
  text: string;
  items: Array<{ id: string | number; text: string }>;
  isListLoading: boolean;
  classNameText?: string;
  onOpen: (value: boolean) => void;
  defaultOpened?: boolean;
}

const ComplaintsReasonsList: FunctionComponent<ComplaintsReasonsListProps> = (props) => {
  const { text, items, isListLoading, classNameText, onOpen, defaultOpened = false } = props;
  const [isOpened, setIsOpened] = useState(defaultOpened);

  const content = useTranslate(componentContent);

  const isDisplayList = isOpened && !!items.length;
  const isDisplayEmptyList = isOpened && !items.length && !isListLoading;

  const classNameIcon = cn(css.icon, { [css.iconActive]: isOpened });
  const classNameContent = cn({
    [css.contentHidden]: !isOpened,
    [css.contentNone]: !(isDisplayList || isDisplayEmptyList),
  });

  const handleOpen = () => {
    setIsOpened(!isOpened);
    onOpen(!isOpened);
  };
  return (
    <div className={css.root}>
      <Space
        className={css.text}
        onClick={handleOpen}
      >
        <Typography.Text className={classNameText}>{text}</Typography.Text>
        <DownOutlined className={classNameIcon} />
      </Space>
      <section className={classNameContent}>
        <Spin spinning={isListLoading}>
          {isDisplayList &&
            items.map((item) => {
              const { id, text } = item;
              return (
                <section
                  key={id}
                  className={css.listItem}
                >
                  <Typography.Paragraph
                    className={css.listItemEllipsisContainer}
                    ellipsis={{
                      rows: 4,
                      expandable: true,
                      symbol: content.show_more,
                    }}
                  >
                    {text}
                  </Typography.Paragraph>
                </section>
              );
            })}
          {isDisplayEmptyList && (
            <Empty
              className={css.emptyContainer}
              imageStyle={{ height: '50px' }}
            />
          )}
        </Spin>
      </section>
    </div>
  );
};

export default ComplaintsReasonsList;
